import createSlideshow from '../modules/slideshow/create_slideshow';
let $els = false;

export default function (slideIndex, backbutton) {
    if (backbutton === true) {
        $els.slick('slickGoTo', parseInt(slideIndex, 10) - 1);
        return false;
    }
    $els = createSlideshow('.fc-header .slide-list, .fc-header .caption-list', true, slideIndex);
}
